import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LangProvider } from "@/i18n/lang";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import CaseStudy from "@/pages/CaseStudy";
import Services from "@/pages/Services";
import Products from "@/pages/Products";
import Contact from "@/pages/Contact";
import Datenschutz from "@/pages/Datenschutz";
import Impressum from "@/pages/Impressum";
import Admin from "@/pages/Admin";
import ServiceLanding from "@/pages/ServiceLanding";
import ProductDetail from "@/pages/ProductDetail";
import NotFound from "@/pages/NotFound";
import { SERVICE_LANDINGS } from "@/content/serviceLandings";
import { PRODUCT_SEO } from "@/content/productSeo";

function MarketingSite() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home locale="de" />} />
        <Route path="/en" element={<Home locale="en" />} />

        <Route path="/work" element={<Work locale="de" />} />
        <Route path="/en/work" element={<Work locale="en" />} />
        <Route path="/work/:slug" element={<CaseStudy locale="de" />} />
        <Route path="/en/work/:slug" element={<CaseStudy locale="en" />} />

        <Route path="/services" element={<Services locale="de" />} />
        <Route path="/en/services" element={<Services locale="en" />} />

        <Route path="/products" element={<Products locale="de" />} />
        <Route path="/en/products" element={<Products locale="en" />} />

        <Route path="/contact" element={<Contact locale="de" />} />
        <Route path="/en/contact" element={<Contact locale="en" />} />

        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/impressum" element={<Impressum />} />
        {SERVICE_LANDINGS.map((s) => [
          <Route key={s.de.path} path={s.de.path} element={<ServiceLanding data={s} locale="de" />} />,
          <Route key={s.en.path} path={s.en.path} element={<ServiceLanding data={s} locale="en" />} />,
        ])}
        {PRODUCT_SEO.map((p) => [
          <Route key={`de-${p.id}`} path={`/de/produkte/${p.de.slug}`} element={<ProductDetail data={p} locale="de" />} />,
          <Route key={`en-${p.id}`} path={`/en/products/${p.en.slug}`} element={<ProductDetail data={p} locale="en" />} />,
        ])}
        {/* Safety redirects: former Lumo slugs -> new slugs (SPA client redirect; no server 301 available) */}
        <Route path="/de/produkte/lumo-universe-roman-reihe" element={<Navigate to="/de/produkte/lumo-elias-kinderbuch-reihe" replace />} />
        <Route path="/en/products/lumo-universe-novel-series" element={<Navigate to="/en/products/lumo-elias-childrens-book-series" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LangProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/admin" element={<Admin />} />
              <Route path="/*" element={<MarketingSite />} />
            </Routes>
            <Toaster position="bottom-right" />
          </BrowserRouter>
        </LangProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
